import { composeIO } from 'react-compose-io'
import { checkListItemIO } from './CheckListItem.IO'
import { CheckListItemView } from './CheckListItem.View'

export const CheckListItem = composeIO(CheckListItemView, checkListItemIO)
